"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var lodash_1 = require("lodash");
var Field_1 = require("../../constants/Field");
var ObjectTypeVariables = /** @class */ (function () {
    /**
     * @param model Object model id
     */
    function ObjectTypeVariables(model) {
        this.path = '#' + model + '/variables';
    }
    /**
     * @param json variables json
     * @param model Object model id
     */
    ObjectTypeVariables.fromJson = function (json, model) {
        var objectTypeVariables = new ObjectTypeVariables(model);
        var nodes = lodash_1.map(Object.keys(json), function (name) {
            return ObjectNode.fromJson(name, json[name], objectTypeVariables.path);
        });
        objectTypeVariables.nodes = nodes;
        return objectTypeVariables;
    };
    ObjectTypeVariables.prototype.toJson = function (objectGuid) {
        var json = Object.create(null);
        lodash_1.map(this.nodes, function (node) {
            if (lodash_1.isEmpty(node.name)) {
                json = Object.assign(json, node.toJson(objectGuid));
            }
            else {
                json[node.name] = node.toJson(objectGuid);
            }
        });
        return json;
    };
    ObjectTypeVariables.prototype.getPathForMatchingVariable = function (name, dataType, objectGuid) {
        var i = 0;
        var result = null;
        do {
            result = this.nodes[i].getPathForMatchingVariable(name, dataType, objectGuid);
            i++;
        } while (result === null && i < this.nodes.length);
        return result;
    };
    return ObjectTypeVariables;
}());
exports.ObjectTypeVariables = ObjectTypeVariables;
var ObjectNode = /** @class */ (function () {
    function ObjectNode(name, parentPath) {
        this.path = parentPath + '/' + name;
        this.name = name;
        this.children = [];
        this.nodes = [];
    }
    /**
     * @param name node name
     * @param json node json
     * @param path node path
     */
    ObjectNode.fromJson = function (name, json, parentPath) {
        var objectNode = new ObjectNode(name, parentPath);
        if (json[Field_1.FIELD.DATATYPE]) {
            var node = DataItem_1.DataItem.fromJson(name, json);
            node.path = objectNode.path;
            objectNode.nodes.push(node);
            objectNode.name = "";
            return objectNode;
        }
        lodash_1.map(Object.keys(json), function (childName) {
            var childNode = json[childName];
            if (childNode[Field_1.FIELD.DATATYPE]) {
                var node = DataItem_1.DataItem.fromJson(childName, childNode);
                node.path = objectNode.path + '/' + childName;
                objectNode.nodes.push(node);
            }
            else {
                var child = ObjectNode.fromJson(childName, childNode, objectNode.path);
                objectNode.children.push(child);
            }
        });
        return objectNode;
    };
    ObjectNode.prototype.getPathForMatchingVariable = function (name, dataType, objectGuid) {
        var matchedItem = lodash_1.find(this.nodes, function (node) {
            return (node.name === name && node.dataType === dataType);
        });
        if (matchedItem !== undefined) {
            return objectGuid + matchedItem.path;
        }
        var result = null;
        if (this.children.length === 0) {
            return result;
        }
        var i = 0;
        do {
            var child = this.children[i];
            result = child.getPathForMatchingVariable(name, dataType, objectGuid);
            i++;
        } while (result === null && i < this.children.length);
        return result;
    };
    ObjectNode.prototype.toJson = function (objectGuid) {
        var json = Object.create(null);
        lodash_1.map(this.children, function (child) {
            json[child.name] = child.toJson(objectGuid);
        });
        lodash_1.map(this.nodes, function (node) {
            var nodeData = node.toJson(false);
            if (objectGuid !== undefined) {
                nodeData[Field_1.FIELD.PATH] = objectGuid + nodeData[Field_1.FIELD.PATH];
            }
            json[node.name] = nodeData;
        });
        return json;
    };
    return ObjectNode;
}());
exports.ObjectNode = ObjectNode;
//# sourceMappingURL=ObjectTypeVariables.js.map